import type { InvestmentObjective } from "~/v2/api/rest/account";

export const INVESTMENT_OBJECTIVE_LABEL = "What is the goal of your account?";

export const INVESTMENT_OBJECTIVE_OPTIONS: {
  label: string;
  value: InvestmentObjective;
}[] = [
  { label: "Preserve wealth", value: "preserve_wealth" },
  { label: "Growth", value: "growth" },
  { label: "Balanced", value: "balance_preserve_wealth_with_growth" },
  { label: "Generate income", value: "generate_income" },
  { label: "Speculation", value: "market_speculation" },
];
